import { IShapeModel } from '../../../../Interface/shape-model.interface';
import { DEFAULT_IMAGE_COLOR, DEFAULT_REGULATE } from '../../../image-operation/constant/props-value';
import { transaction } from '@src/slide/domain/slide-app';
import { FillType } from '../../fill.interface';
import ImageEffect from '../../../image-operation/image-effect';
import { IImageFillEffect } from './image-fill-effect.interface';

const DEFAULT_ALPHA = 1;

export class ImageFillEffect extends ImageEffect implements IImageFillEffect {
    private shapeModel: IShapeModel;
    public constructor(model: IShapeModel) {
        super(model);
        this.shapeModel = model;
    }
    /**
     * 图片透明度
     */
    public handleImageAlpha(values, options?): void {
        const fillType = this.shapeModel.getBackgroundFill().getFillType();
        if (fillType !== FillType.ImageFill) return;
        this.shapeModel.getBackgroundFill().updateCurrentFill({
            image: {
                ...this.shapeModel.getBackgroundFill().getCurrentFill()?.fillInfo,
                ...values.image,
            },
        }, options?.onlyChangeUI);
    }

    /**
     * 重置图片效果
     */
    public handleResetPicture(): void {
        const fillInfo = this.shapeModel.getBackgroundFill().getFillInfo();
        if (!fillInfo?.image) return;
        const blip = {
            ...DEFAULT_REGULATE,
            ...DEFAULT_IMAGE_COLOR,
            grayscl: false,
            duotone: null,
            biLevel: null,
            luminance: null,
        };
        transaction(() => {
            if (fillInfo.image?.alpha) {
                this.handleImageAlpha({ image: { alpha: DEFAULT_ALPHA } });
            }
            Object.keys(blip).forEach((p) => {
                blip[p] = null;
            });
            this.shapeModel.updateProps({ style: { image: { ...blip } } });
        });
    }
}
